import CancelBackButton from "components/Buttons/CancelBackButton";
import React from "react";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";

interface SupplierDetails {
  supplier_name?: string;
  supplier_code?: string;
  email?: string;
  phone_no?: string;
  address?: string;
  country?: string;
  state?: string;
  city?: string;
  pincode?: string;
  gst_in?: string;
  contact_person_name?: string;
  contact_person_phone_no?: string;
  transporter_details?: Array<{
    transporter_name?: string;
    transporter_contact_person_name?: string;
    transporter_contact_person_phone_no?: string;
  }>;
}

interface SupplierViewDetailsModalProps {
  show: boolean;
  onHide: () => void;
  supplierDetails: SupplierDetails | null;
  loading: boolean;
}

const SupplierViewDetailsModal: React.FC<SupplierViewDetailsModalProps> = ({
  show,
  onHide,
  supplierDetails,
  loading,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Supplier Information</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : supplierDetails ? (
          <>
            <Row>
              <Col lg={12}>
                <div className="mb-0">
                  <h6 className="mb-3">
                    <strong>Supplier Information</strong>
                  </h6>
                  <Row>
                    <Col lg={4} className="mb-3">
                      <div>
                        <label
                          className="form-label me-1"
                          style={{ fontWeight: "500", color: "#495057" }}
                        >
                          Supplier Name:
                        </label>
                        {supplierDetails?.supplier_name || "—"}
                      </div>
                    </Col>
                    <Col lg={4} className="mb-3">
                      <div>
                        <label
                          className="form-label me-1"
                          style={{ fontWeight: "500", color: "#495057" }}
                        >
                          Supplier Code:
                        </label>
                        {supplierDetails?.supplier_code || "—"}
                      </div>
                    </Col>
                    <Col lg={4} className="mb-3">
                      <div>
                        <label
                          className="form-label me-1"
                          style={{ fontWeight: "500", color: "#495057" }}
                        >
                          GSTIN:
                        </label>
                        {supplierDetails?.gst_in || "—"}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <hr />

            <Row>
              <Col lg={12}>
                <div className="mb-0">
                  <h6 className="mb-3">
                    <strong>Contact Details</strong>
                  </h6>
                  <Row>
                    <Col lg={4} className="mb-3">
                      <div>
                        <label
                          className="form-label me-1"
                          style={{ fontWeight: "500" }}
                        >
                          Email:
                        </label>
                        {supplierDetails?.email || "—"}
                      </div>
                    </Col>
                    <Col lg={4} className="mb-3">
                      <div>
                        <label
                          className="form-label me-1"
                          style={{ fontWeight: "500" }}
                        >
                          Phone Number:
                        </label>

                        {supplierDetails?.phone_no
                          ? `+91-${supplierDetails.phone_no}`
                          : "—"}
                      </div>
                    </Col>
                    <Col lg={4} className="mb-3">
                      <div>
                        <label
                          className="form-label me-1"
                          style={{ fontWeight: "500" }}
                        >
                          Address:
                        </label>
                        {supplierDetails?.address || "—"}
                      </div>
                    </Col>
                    <Col lg={4} className="mb-3">
                      <div>
                        <label
                          className="form-label me-1"
                          style={{ fontWeight: "500" }}
                        >
                          City:
                        </label>
                        {supplierDetails?.city || "—"}
                      </div>
                    </Col>
                    <Col lg={4} className="mb-3">
                      <div>
                        <label
                          className="form-label me-1"
                          style={{ fontWeight: "500" }}
                        >
                          State:
                        </label>
                        {supplierDetails?.state || "—"}
                      </div>
                    </Col>
                    <Col lg={4} className="mb-3">
                      <div>
                        <label
                          className="form-label me-1"
                          style={{ fontWeight: "500" }}
                        >
                          Pincode:
                        </label>
                        {supplierDetails?.pincode || "—"}
                      </div>
                    </Col>
                    <Col lg={4} className="mb-3">
                      <div>
                        <label
                          className="form-label me-1"
                          style={{ fontWeight: "500" }}
                        >
                          Country:
                        </label>
                        {supplierDetails?.country || "—"}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <hr />

            <Row>
              <Col lg={12}>
                <div className="mb-0">
                  <h6 className="mb-3">
                    <strong>Contact Person</strong>
                  </h6>
                  <Row>
                    <Col lg={4} className="mb-3">
                      <div>
                        <label
                          className="form-label me-1"
                          style={{ fontWeight: "500" }}
                        >
                          Contact Person Name:
                        </label>
                        {supplierDetails?.contact_person_name || "—"}
                      </div>
                    </Col>
                    <Col lg={4} className="mb-3">
                      <div>
                        <label
                          className="form-label me-1"
                          style={{ fontWeight: "500" }}
                        >
                          Phone No:
                        </label>
                        {supplierDetails?.contact_person_phone_no
                          ? `+91-${supplierDetails.contact_person_phone_no}`
                          : "—"}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
              <hr />
            <Row>

              <Col lg={12}>
                <div className="mb-0">
                  <h6 className="mb-3">
                    <strong>Transporter Details</strong>
                  </h6>
                  {supplierDetails?.transporter_details &&
                    supplierDetails.transporter_details?.length > 0 ? (
                    supplierDetails?.transporter_details?.map(
                      (transporter, index) => (
                        <Row key={index} className="mb-3">
                          <Col lg={4} className="mb-3">
                            <div>
                              <label
                                className="form-label me-1"
                                style={{ fontWeight: "500", color: "#495057" }}
                              >
                                Transporter Name {index + 1}:
                              </label>
                              {transporter?.transporter_name || "—"}
                            </div>
                          </Col>
                          <Col lg={4} className="mb-3">
                            <div>
                              <label
                                className="form-label me-1"
                                style={{ fontWeight: "500", color: "#495057" }}
                              >
                                Contact Person Name:
                              </label>
                              {transporter?.transporter_contact_person_name ||
                                "—"}
                            </div>
                          </Col>
                          <Col lg={4} className="mb-3">
                            <div>
                              <label
                                className="form-label me-1"
                                style={{ fontWeight: "500", color: "#495057" }}
                              >
                                Phone No:
                              </label>
                              {transporter?.transporter_contact_person_phone_no
                                ? `+91-${transporter.transporter_contact_person_phone_no}`
                                : "—"}
                            </div>
                          </Col>
                        </Row>
                      )
                    )
                  ) : (
                    <Row>
                      <Col lg={4} className="mb-3">
                        <div>
                          <label
                            className="form-label me-1"
                            style={{ fontWeight: "500", color: "#495057" }}
                          >
                            Transporter Name 1:
                          </label>
                          <div
                            style={{
                              padding: "8px 12px",
                              border: "1px solid #ced4da",
                              borderRadius: "4px",
                              backgroundColor: "#f8f9fa",
                              minHeight: "38px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            —
                          </div>
                        </div>
                      </Col>
                      <Col lg={4} className="mb-3">
                        <div>
                          <label
                            className="form-label me-1"
                            style={{ fontWeight: "500", color: "#495057" }}
                          >
                            Contact Person Name:
                          </label>
                          <div
                            style={{
                              padding: "8px 12px",
                              border: "1px solid #ced4da",
                              borderRadius: "4px",
                              backgroundColor: "#f8f9fa",
                              minHeight: "38px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            —
                          </div>
                        </div>
                      </Col>
                      <Col lg={4} className="mb-3">
                        <div>
                          <label
                            className="form-label me-1"
                            style={{ fontWeight: "500", color: "#495057" }}
                          >
                            Phone No:
                          </label>
                          <div
                            style={{
                              padding: "8px 12px",
                              border: "1px solid #ced4da",
                              borderRadius: "4px",
                              backgroundColor: "#f8f9fa",
                              minHeight: "38px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            —
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <div className="text-center py-4">
            <p className="text-muted">No supplier details available</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-center w-100">
          <CancelBackButton onClick={onHide} label="Close" />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default SupplierViewDetailsModal;
